import { render, staticRenderFns } from "./PontoFichaPontoValidada.vue?vue&type=template&id=1c3c110b&"
import script from "./PontoFichaPontoValidada.vue?vue&type=script&lang=js&"
export * from "./PontoFichaPontoValidada.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./PontoFichaPontoValidada.vue?vue&type=style&index=1&id=1c3c110b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports